"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { AlertCircle, RefreshCw } from "lucide-react";

export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex items-center justify-center min-h-[60vh] p-6">
      <div className="text-center max-w-md">
        <div className="h-12 w-12 rounded-full bg-red-50 border border-red-200 flex items-center justify-center mx-auto mb-4">
          <AlertCircle className="h-6 w-6 text-red-500" />
        </div>
        <h2 className="font-heading text-[16px] text-text-primary mb-2">
          Something went wrong
        </h2>
        <p className="text-[12px] font-body text-text-secondary mb-1 leading-relaxed">
          An unexpected error occurred. This has been logged automatically.
        </p>
        {error.digest && (
          <p className="text-[10px] font-mono text-text-muted mb-4">
            Error ID: {error.digest}
          </p>
        )}
        <button
          onClick={reset}
          className="inline-flex items-center gap-1.5 h-8 px-4 rounded-md text-[12px] font-body bg-accent-blue hover:bg-accent-hover text-white transition-colors shadow-sm"
        >
          <RefreshCw className="h-3.5 w-3.5" />
          Try again
        </button>
      </div>
    </div>
  );
}
